/**
 * Inline "text with $LaTeX$" renderer for non-Markdown spots (homework
 * preview list etc.). Plain text when there is no math, so the common
 * case costs nothing and keeps React's own escaping.
 */
import { hasMath, mathToHtml } from "../lib/mathText";

export function MathText({ text, className }: { text: string; className?: string }) {
  if (!hasMath(text)) return <span className={className}>{text}</span>;
  return <span className={className} dangerouslySetInnerHTML={{ __html: mathToHtml(text) }} />;
}
